document.addEventListener('DOMContentLoaded', function() {
    "use strict";
    
    // Add click event listeners to all layout selection buttons
    const selectButtons = document.querySelectorAll('.select-btn.zwssgr-select-btn');
    
    if (selectButtons.length > 0) {
        // console.log('Found ' + selectButtons.length + ' layout selection buttons');
        
        selectButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Get the layout option and display option from the button's data attributes
                const layoutOption = this.getAttribute('data-option');
                const displayOption = this.getAttribute('data-display-option');
                const postId = new URLSearchParams(window.location.search).get('zwssgr_widget_id');
                
                // console.log('Button clicked:', layoutOption, displayOption, postId);
                
                if (!postId || !layoutOption || !displayOption) {
                    console.error('Missing required parameters');
                    return;
                }
                
                // Show loading indicator
                document.body.classList.add('zwssgr-loading');
                
                // Make a direct AJAX call to update the shortcode
                const xhr = new XMLHttpRequest();
                xhr.open('POST', ajaxurl, true);
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                
                const params = new URLSearchParams({
                    action: 'zwssgr_update_shortcode',
                    post_id: postId,
                    layout: displayOption,
                    layout_option: layoutOption
                });
                
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        try {
                            const response = JSON.parse(xhr.responseText);
                            if (response.success) {
                                // Redirect to the URL provided by the server
                                window.location.href = response.data.redirect_url;
                            } else {
                                alert('Error: ' + (response.data ? response.data.message : 'Unknown error'));
                                document.body.classList.remove('zwssgr-loading');
                            }
                        } catch (e) {
                            console.error('Invalid response', e);
                            document.body.classList.remove('zwssgr-loading');
                        }
                    } else {
                        console.error('Request failed', xhr.statusText);
                        document.body.classList.remove('zwssgr-loading');
                    }
                };
                
                xhr.onerror = function() {
                    console.error('Request failed');
                    document.body.classList.remove('zwssgr-loading');
                };
                
                xhr.send(params.toString());
            });
        });
    } else {
        // console.log('No layout selection buttons found');
    }
});
